import { defineModule } from '../../manifest.js';
/**
 * Compliance & Risk — an approved Phase 1 SKU.
 *
 * REGISTERED, NOT BUILT, on the same terms as Procurement: no tables, no
 * package, no permissions, no routes, no features, no metered events, and one
 * base edition. `lifecycle: 'proposed'` is the honest state.
 *
 * THE KEY IS `compliance-risk` AND THE KERNEL IS `compliance_kernel`.
 * Documents & Contracts, Field Service, HR and LMS all declare
 * `requiredCore: ['compliance_kernel']` — the mandatory compliance context
 * every tenant has. None of them requires this module, and none of them
 * changes behaviour when a tenant buys it. The key is deliberately not
 * `compliance`: that name belongs to the kernel, and a sellable module key
 * that collided with it would make every one of those four declarations
 * ambiguous between something mandatory and something optional (§5).
 */
export const manifest = defineModule({
    moduleKey: 'compliance-risk',
    name: 'Compliance & Risk',
    description: 'Obligations, controls, risk register, policy attestation and compliance evidence.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'compliance',
    features: [],
    editions: [{ code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] }],
    limitTypes: ['user'],
    meteredEvents: [],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'approvals',
        'compliance_kernel',
        'attachments',
        'tasks',
        'notifications',
    ],
    optionalModules: [],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map